module.exports = __webpack_public_path__ + "img/1488263292.c16cb219.jpg";